import axiosInstance from "../../utils/axiosCompany";

export const LogoutUserService = async (values) => {
    return await axiosInstance().post("company/user/logout-user", values);
}

export const GetEditProfile = async (values) => {
    return await axiosInstance().post("company/user/editprofile", values);
}

export const GetProfileDetail = async (id) => {
    return await axiosInstance().get(`company/user/get-edit-profile?id=${id}`);
}

export const ChangePassword = async (values) => {
    return await axiosInstance().post("company/user/change-password", values);
}

export const GetPermission = async (company_id, id) => {
    return await axiosInstance().get(`company/user/get-permission?company_id=${company_id}&id=${id}`);
}
